<script setup lang="ts">
import { cn } from '@/utils';

import { SEARCH_PLACEHOLDERS } from '.';

interface SearchSuggestFallbackProps {
	inputWrapperClasses?: string;
	inputClasses?: string;
	inputSearchIconWrapperClasses?: string;
	inputSearchIconClasses?: string;
	buttonInputClasses?: string;
	placeholderClasses?: string;
	placeholder?: string;
	isButton?: boolean;
	disabled?: boolean;
}

const props = withDefaults(defineProps<SearchSuggestFallbackProps>(), {
	inputWrapperClasses: '',
	inputClasses: '',
	inputSearchIconWrapperClasses: 'grid h-full w-[62px] place-items-center',
	inputSearchIconClasses: 'size-7 text-primary',
	buttonInputClasses: '',
	placeholderClasses: 'truncate text-left text-primary-light-1',
	placeholder: SEARCH_PLACEHOLDERS.primary,
	isButton: false,
	disabled: true
});

const emit = defineEmits<{
	(e: 'click'): void;
}>();
</script>

<template>
	<div
		v-if="isButton"
		:class="cn('flex size-full items-center', inputWrapperClasses)"
	>
		<button
			:class="
				cn(
					'z-10 flex h-11 flex-1 min-w-0 items-center text-ellipsis rounded-md bg-white text-primary',
					buttonInputClasses
				)
			"
			@click="emit('click')"
		>
			<span :class="cn(placeholderClasses)">
				{{ placeholder }}
			</span>
		</button>
		<div class="ml-auto flex items-center">
			<div :class="cn(inputSearchIconWrapperClasses)">
				<IconMaterialSymbolsLightSearch :class="cn(inputSearchIconClasses)" />
			</div>
		</div>
	</div>

	<div v-else :class="cn('flex size-full items-center', inputWrapperClasses)">
		<input
			:class="
				cn(
					'h-[50px] w-full md:h-14 md:pl-5 pl-4 text-sm md:text-base placeholder:text-primary-light-1',
					inputClasses
				)
			"
			:placeholder="placeholder"
			:disabled="disabled"
		/>
		<div :class="cn(inputSearchIconWrapperClasses)">
			<IconMaterialSymbolsLightSearch :class="cn(inputSearchIconClasses)" />
		</div>
	</div>
</template>
